<script setup lang="ts">
import { computed, inject, ref, watch } from "vue";
import { useConfigurationsStore } from "../../../../stores";

interface AcademicQualificationForm {
  name: string | null
}

const store = useConfigurationsStore();
const successToast = inject<any>('successToast')
const errorToast = inject<any>('errorToast')

const form = ref<AcademicQualificationForm>({
  name: null
})
const spinner = ref(false)

const academicQualification = computed(() => store.academicQualification);
const insolvencyError = computed(() => store.insolvencyError);

const addBody = () => {
  spinner.value = true
  store.createAcademicQualification(form.value);
}

watch(academicQualification, () => {
  spinner.value = false
  store.fetchAcademicQualifications();
  successToast?.('Success', 'Academic Qualification created successfully')
})

watch(insolvencyError, () => {
  spinner.value = false
  errorToast?.('Error', 'An error occurred while creating academic qualification')
})
</script>

<template>
  <div class="p-4">
    <div class="space-y-4">
      <div>
        <label class="text-xs font-semibold text-gray-600 uppercase tracking-wide">Name</label>
        <input
          type="text"
          v-model="form.name"
          class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-gray-50"
          placeholder="e.g. Bachelors"
          required
        />
      </div>

      <div class="flex justify-end gap-2">
        <button
          @click="addBody"
          :disabled="spinner"
          class="btn-primary"
        >
          <span>Save</span>
        </button>
      </div>
    </div>
  </div>
</template>
